import { render, staticRenderFns } from "./agreementList.vue?vue&type=template&id=4ad94a10&scoped=true&"
import script from "./agreementList.vue?vue&type=script&lang=js&"
export * from "./agreementList.vue?vue&type=script&lang=js&"
import style0 from "./agreementList.vue?vue&type=style&index=0&id=4ad94a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad94a10",
  null
  
)

export default component.exports